import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { selectRuntimeLicence } from '../../../../selectors/runtime/runtimePrimary.selector';
import {
  selectUserDidReceivedUserData,
  selectUserPromotionStatus,
} from '../../../../selectors/user/userPrimary.selector';

import Missions from './Missions';

type MissionsContainerProps = {
  className?: string;
};

const MissionsContainer = (ownProps: MissionsContainerProps) => {
  const licence = useSelector(selectRuntimeLicence);
  const promotionStatus = useSelector(selectUserPromotionStatus);
  const didReceivedUserData = useSelector(selectUserDidReceivedUserData);

  const selectedProps = useMemo(
    () => ({ licence, promotionStatus, didReceivedUserData }),
    [licence, promotionStatus, didReceivedUserData],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <Missions {...enhancedProps} />;
};

export default MissionsContainer;
